import React from "react";
import styled from "styled-components";
import { BrandLogo } from "../brandLogo";
import { Button } from "../button";
import { Marginer } from "../marginer";

import { Link } from "react-router-dom";
import { deviceSize } from "../responsive";
import { useMediaQuery } from "react-responsive";

const NavbarContainer = styled.div`
  width: 100%;
  height: 95px;
  display: flex;
  padding-right:100px;
  padding-left:60px;
  align-items: center;
  margin-top:10px;
  justify-content: space-between;


  background-color: ${({ useTransparent }) =>
    useTransparent ? "transparent" : "#264653"};
`;

const AccessibilityContainer = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
`;

const AnchorLink = styled(Link)`
  font-size: 12px;
  color: #fff;
  cursor: pointer;
  text-decoration: none;
  outline: none;
  transition: all 200ms ease-in-out;

  &:hover {
    filter: contrast(0.6);
  }
`;

const ButtonName = styled.div`
border-radius:36px;
padding:6px;
background-color:#ffffff;
text-decoration:none;
width:150px;
color:#000080;


`
const Seperator = styled.div`
  min-height: 35%;
  width: 1px;
  background-color: #fff;
`;

const LabelL = styled.div` 
color:#ffffff;

`

export function Navbar(props) {
  const { useTransparent } = props;

  const isMobile = useMediaQuery({ maxWidth: deviceSize.mobile });

  return (
    <NavbarContainer useTransparent={useTransparent}>
      <BrandLogo />
      <AccessibilityContainer>
        {!isMobile && <LabelL>Somatto.org.br </LabelL>}
        {!isMobile && <Marginer direction="horizontal" margin={10} />}
        {!isMobile && <Seperator />}
        <Marginer direction="horizontal" margin={10} />
        {!isMobile && <LabelL>0800 770 55 30 </LabelL>}
        <Marginer direction="horizontal" margin={8} />
       
      </AccessibilityContainer>
    </NavbarContainer>
  );
}
